declare global {
  interface ImportMetaEnv {
    VITE_MORPHCAST_ACTIVE: string;
    VITE_ENTROPIK_API_KEY: string;
    VITE_MORPHCAST_API_KEY: string;
    VITE_ENTROPIK_USERNAME: string;
    VITE_APP_MODE: string;
    VITE_VAD_SOCKET_SERVER_URL: string;
    VITE_DATA_VORTEX_API_URL: string;
    VITE_BASE_WHITEBOARD_PLUGIN_ID: string;
    VITE_EMOTION_ENABLED_CLASS_IDS: string;
    VITE_EMOTION_ENABLED_STUDENT_IDS: string;
    VITE_SUGGESTION_TYPES: string;
    VITE_NUDGE_TYPES: string;
    VITE_POLLING_INTERVAL: string;
    VITE_BACKEND_URL: string;
    VITE_SANITY_PROJECT_ID: string;
    VITE_SANITY_DATASET: string;
    // LiveKit configuration
    VITE_LIVEKIT_WS_URL: string;
    // Auto-end recording on an empty room
    VITE_AUTO_END_RECORDING_ENABLED: string;
    VITE_AUTO_END_RECORDING_MINUTES: string;
  }

  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }
}

export const MORPHCAST_ACTIVE = import.meta.env.VITE_MORPHCAST_ACTIVE;
export const EMOTION_API_KEY = import.meta.env.VITE_ENTROPIK_API_KEY;
export const MORPHCAST_API_KEY = import.meta.env.VITE_MORPHCAST_API_KEY;
export const EMOTION_USERNAME = import.meta.env.VITE_ENTROPIK_USERNAME;
export const NODE_ENV = import.meta.env.VITE_APP_MODE;
export const VAD_SOCKET_SERVER_URL = import.meta.env.VITE_VAD_SOCKET_SERVER_URL;
export const VITE_DATA_VORTEX_API_URL = import.meta.env.VITE_DATA_VORTEX_API_URL;
export const WHITEBOARD_PLUGIN_ID = import.meta.env.VITE_BASE_WHITEBOARD_PLUGIN_ID || '';
export const SUGGESTION_TYPES = import.meta.env.VITE_SUGGESTION_TYPES || '';
export const NUDGE_TYPES = import.meta.env.VITE_NUDGE_TYPES || '';
// New config for emotion detection
export const EMOTION_ENABLED_CLASS_IDS = import.meta.env.VITE_EMOTION_ENABLED_CLASS_IDS?.split(',') || [];
export const EMOTION_ENABLED_STUDENT_IDS = import.meta.env.VITE_EMOTION_ENABLED_STUDENT_IDS?.split(',') || [];
export const POLLING_INTERVAL = import.meta.env.VITE_POLLING_INTERVAL || 10000;
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || '';
export const SANITY_PROJECT_ID = import.meta.env.VITE_SANITY_PROJECT_ID || '';
export const SANITY_DATASET = import.meta.env.VITE_SANITY_DATASET || '';

// LiveKit configuration
export const LIVEKIT_WS_URL = import.meta.env.VITE_LIVEKIT_WS_URL || '';

// Auto-end the recording once the class room has had no tutor/student for a
// sustained window (the egress bot otherwise records an empty room until the
// class-end flow stops it). Default ON; disable by setting the flag to 'false'.
export const AUTO_END_RECORDING_ENABLED =
  (import.meta.env.VITE_AUTO_END_RECORDING_ENABLED ?? 'true').toLowerCase() !==
  'false';
// Minutes the room must stay empty before we stop. Env-tunable; default 5.
export const AUTO_END_RECORDING_MINUTES =
  Number(import.meta.env.VITE_AUTO_END_RECORDING_MINUTES) || 5;